<template>
    <v-sheet
        elevation=0
        @dragover.prevent
        @drop.prevent="addDropFile"
    >
        <ui-multiple-file-input
		ref="multipleFileInput"
            v-model="files"
            :rules="rules"
            :accept="accept"
            :height="150"
            placeholder="クリックしてファイルを選択、またはこのエリアにファイルをドラッグ&ドロップ"
        />
    </v-sheet>
</template>

<script>
export default {
	name: 'UiDragAndDropFileInput',
    model: {
        prop: 'value',
    },
    props: {
        value: {
            type: Array,
            default: function () {
                return [];
            }
        },
        rules: {
            type: Array,
            default: function () {
                return [];
            }
        },
        accept: {
            type: [String, Array],
            default: ''
        },
    },
    computed: {
        files: {
            get: function () {
                return this.value;
            },
            set: function (val) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        addDropFile: function (e) {
			let droppedFiles = e.dataTransfer.files;
			this.$refs.multipleFileInput.changeFile(droppedFiles);
        },
    },
}
</script>
